import { Swiper } from 'swiper'
import { Autoplay, Pagination, Navigation } from 'swiper/modules'

Swiper.use([Pagination])
Swiper.use([Autoplay])
Swiper.use([Navigation])

export default () => ({
    carousel: null,

    init() {
        this.carousel = new Swiper('.swiper-care-home-accommodation-carousel-instance', {
            slidesPerView: 1,
            spaceBetween: 26,
            speed: 1500,
            effect: "fade",
            loop: true,
            preventInteractionOnTransition: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        })
    },
})
